// Removes items on object based on property
export var cleanObject = function cleanObject(obj, key) {
  var data = obj.filter(function (item) {
    if (item.children) {
      var _item$url;

      if (!(item === null || item === void 0 ? void 0 : (_item$url = item.url) === null || _item$url === void 0 ? void 0 : _item$url.startsWith('/Locations'))) {
        item.children = cleanObject(item.children, key);
      } else {// mobile need the states so no cleaning for u 
      }
    }

    return typeof item[key] !== 'undefined' && item[key].value !== '' ? null : item;
  });
  return data;
};
export var cleanTitleObject = function cleanTitleObject(obj, key) {
  var data = obj.filter(function (item) {
    if (item.children) {
      item.children = cleanTitleObject(item.children, key);
    }

    return typeof item[key] === 'undefined' || item[key].value === '' ? null : item;
  });
  return data;
};